import { render, staticRenderFns } from "./AdminSubCategory.vue?vue&type=template&id=0201bc69&scoped=true&"
import script from "./AdminSubCategory.vue?vue&type=script&lang=js&"
export * from "./AdminSubCategory.vue?vue&type=script&lang=js&"
import style0 from "./AdminSubCategory.vue?vue&type=style&index=0&id=0201bc69&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0201bc69",
  null
  
)

export default component.exports